<template>
  <div>
    <div v-if="data">
      <div v-for="(widgetItem, key1) in props" :key="key1">
        <div class="block-content">
          <div class="table-responsive">
            <table
              v-if="widgetItem[0]"
              class="
                js-table-checkable
                table table-hover table-vcenter
                js-table-checkable-enabled
              "
            >
              <thead>
                <tr>
                  <th class="text-center" style="width: 70px"></th>
                  <th class="d-sm-table-cell">
                    {{ widgetItem[0].category_name[lang] }}
                  </th>
                  <th class="d-sm-table-cell text-right">
                    {{ translate[lang]["permonth"] }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style="white-space: nowrap; overflow-x: auto; width: 100%"
                  v-for="(item, key) in widgetItem"
                  :key="key"
                  @click="changeStatus(item.id, key1)"
                  v-if="
                    item.rate_period.indexOf(getRatePeriod(group)) != -1 &&
                    group === 'mobile'
                  "
                >
                  <td>
                    <div
                      class="
                        custom-control custom-radio custom-control-primary
                        d-inline-block
                      "
                    >
                      <input
                        :id="'widget' + key1 + item.id"
                        type="radio"
                        class="custom-control-input"
                        :name="'products[' + group + '][package][' + key1 + ']'"
                        :checked="item.default ? true : false"
                        :value="item.id"
                      />
                      <label
                        class="custom-control-label"
                        :for="'widget' + key1 + item.id"
                      ></label>
                    </div>
                  </td>
                  <td>{{ parseJSONSupplierName(item.name, lang) }}</td>

                  <td class="text-right d-sm-table-cell">
                    <span
                      v-if="item.packagesdiff !== 0"
                      style="display: inline-block; left: 0"
                    >
                      <span v-if="item.packagesdiff > 0">+</span>
                      <span v-if="item.packagesdiff < 0">-</span>
                      €
                      {{ formatPrice(Math.abs(item.packagesdiff)) }}/
                      <span class="badge badge-success font-w300">{{
                        translate[lang]["month"]
                      }}</span>
                    </span>
                  </td>
                </tr>
                <tr
                  style="white-space: nowrap; overflow-x: auto; width: 100%"
                  v-for="(item, key) in widgetItem"
                  :key="key"
                  @click="changeStatus(item.id, key1)"
                  v-if="
                    item.rate_period.indexOf(getRatePeriod(group)) != -1 &&
                    group === 'internet' &&
                    item.title != 'Youfone'
                  "
                >
                  <td>
                    <div
                      class="
                        custom-control custom-radio custom-control-primary
                        d-inline-block
                      "
                    >
                      <input
                        :id="'widget' + key1 + item.id"
                        type="radio"
                        class="custom-control-input"
                        :name="'products[' + group + '][package][' + key1 + ']'"
                        :checked="item.default ? true : false"
                        :value="item.id"
                      />
                      <label
                        class="custom-control-label"
                        :for="'widget' + key1 + item.id"
                      ></label>
                    </div>
                  </td>

                  <td>
                    <a
                      style="z-index: 110"
                      class="more"
                      data-toggle="modal"
                      data-target="#computedInfo"
                      @click="openModal(item, $event)"
                      v-if="item.info"
                    >
                      <i
                        style="color: #0665d0"
                        class="fas fa-info-circle fa"
                      ></i>
                    </a>
                    {{ parseJSONSupplierName(item.name, lang) }}
                  </td>

                  <td class="text-right d-sm-table-cell">
                    <span
                      v-if="item.packagesdiff !== 0"
                      style="display: inline-block; left: 0"
                    >
                      <span v-if="item.packagesdiff > 0">+</span>
                      <span v-if="item.packagesdiff < 0">-</span>
                      €
                      {{ formatPrice(Math.abs(item.packagesdiff)) }}/
                      <span class="badge badge-success font-w300">{{
                        translate[lang]["month"]
                      }}</span>
                    </span>
                  </td>
                </tr>
                <tr
                  style="white-space: nowrap; overflow-x: auto; width: 100%"
                  v-for="(item, key) in widgetItem"
                  :key="key"
                  @click="changeStatus(item.id, key1)"
                  v-if="
                    item.rate_period.indexOf(getRatePeriod(group)) != -1 &&
                    group === 'internet' &&
                    item.title === 'Youfone' &&
                    item.category_field === 'internet' &&
                    checkYoufone &&
                    checkYoufone.speed &&
                    checkYoufone.speed.type === 'Fiber' &&
                    (parseJSONSupplierName(item.name, lang).split(' ')[0] ===
                      'Fiber' ||
                      parseJSONSupplierName(item.name, lang).split(' ')[0] ===
                        'Glasvezel')
                  "
                >
                  <td>
                    <div
                      class="
                        custom-control custom-radio custom-control-primary
                        d-inline-block
                      "
                    >
                      <input
                        :id="'widget' + key1 + item.id"
                        type="radio"
                        class="custom-control-input"
                        :name="'products[' + group + '][package][' + key1 + ']'"
                        :checked="item.default ? true : false"
                        :value="item.id"
                      />
                      <label
                        class="custom-control-label"
                        :for="'widget' + key1 + item.id"
                      ></label>
                    </div>
                  </td>
                  <td>{{ parseJSONSupplierName(item.name, lang) }}</td>

                  <td class="text-right d-sm-table-cell">
                    <span
                      v-if="item.packagesdiff !== 0"
                      style="display: inline-block; left: 0"
                    >
                      <span v-if="item.packagesdiff > 0">+</span>
                      <span v-if="item.packagesdiff < 0">-</span>
                      €
                      {{ formatPrice(Math.abs(item.packagesdiff)) }}/
                      <span class="badge badge-success font-w300">{{
                        translate[lang]["month"]
                      }}</span>
                    </span>
                  </td>
                </tr>
                <tr
                  style="white-space: nowrap; overflow-x: auto; width: 100%"
                  v-for="(item, key) in widgetItem"
                  :key="key"
                  @click="changeStatus(item.id, key1)"
                  v-if="
                    item.rate_period.indexOf(getRatePeriod(group)) != -1 &&
                    group === 'internet' &&
                    item.title === 'Youfone' &&
                    item.category_field === 'internet' &&
                    checkYoufone &&
                    checkYoufone.speed &&
                    checkYoufone.speed.type === 'Dsl' &&
                    parseJSONSupplierName(item.name, lang).split(' ')[0] ===
                      'DSL'
                  "
                >
                  <td>
                    <div
                      class="
                        custom-control custom-radio custom-control-primary
                        d-inline-block
                      "
                    >
                      <input
                        :id="'widget' + key1 + item.id"
                        type="radio"
                        class="custom-control-input"
                        :name="'products[' + group + '][package][' + key1 + ']'"
                        :checked="item.default ? true : false"
                        :value="item.id"
                      />
                      <label
                        class="custom-control-label"
                        :for="'widget' + key1 + item.id"
                      ></label>
                    </div>
                  </td>
                  <td>{{ parseJSONSupplierName(item.name, lang) }}</td>

                  <td class="text-right d-sm-table-cell">
                    <span
                      v-if="item.packagesdiff !== 0"
                      style="display: inline-block; left: 0"
                    >
                      <span v-if="item.packagesdiff > 0">+</span>
                      <span v-if="item.packagesdiff < 0">-</span>
                      €
                      {{ formatPrice(Math.abs(item.packagesdiff)) }}/
                      <span class="badge badge-success font-w300">{{
                        translate[lang]["month"]
                      }}</span>
                    </span>
                  </td>
                </tr>
                <tr
                  style="white-space: nowrap; overflow-x: auto; width: 100%"
                  v-for="(item, key) in widgetItem"
                  :key="key"
                  @click="changeStatus(item.id, key1)"
                  v-if="
                    item.rate_period.indexOf(getRatePeriod(group)) != -1 &&
                    group === 'internet' &&
                    item.title === 'Youfone' &&
                    item.category_field !== 'internet'
                  "
                >
                  <td>
                    <div
                      class="
                        custom-control custom-radio custom-control-primary
                        d-inline-block
                      "
                    >
                      <input
                        :id="'widget' + key1 + item.id"
                        type="radio"
                        class="custom-control-input"
                        :name="'products[' + group + '][package][' + key1 + ']'"
                        :checked="item.default ? true : false"
                        :value="item.id"
                      />
                      <label
                        class="custom-control-label"
                        :for="'widget' + key1 + item.id"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <a
                      style="z-index: 110"
                      class="more"
                      data-toggle="modal"
                      data-target="#computedInfo"
                      @click="openModal(item, $event)"
                      v-if="item.info !== null"
                    >
                      <i
                        style="color: #0665d0"
                        class="fas fa-info-circle fa"
                      ></i>
                    </a>
                    {{ parseJSONSupplierName(item.name, lang) }}
                  </td>
                  <td class="text-right d-sm-table-cell">
                    <span
                      v-if="item.packagesdiff !== 0"
                      style="display: inline-block; left: 0"
                    >
                      <span v-if="item.packagesdiff > 0">+</span>
                      <span v-if="item.packagesdiff < 0">-</span>
                      €
                      {{ formatPrice(Math.abs(item.packagesdiff)) }}/
                      <span class="badge badge-success font-w300">{{
                        translate[lang]["month"]
                      }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import _ from "lodash";
export default {
  name: "PropWidgets",
  props: ["data", "supplier", "group", "index"],
  data() {
    return {
      regexNumber: /\d+/,
      kpn: null,
      youfone: null,
      tmobile: null,
      ziggo: null,
    };
  },
  watch: {
    checkZiggo(val) {
      this.ziggo = val;
    },
    checkKpn(val) {
      this.kpn = val;
    },
    checkTmobile(val) {
      this.tmobile = val;
    },
    checkYoufone(val) {
      this.youfone = val;
    },
  },
  created() {},
  computed: {
    ...mapState({
      checkZiggo: (state) => state.forms.checkZiggo,
      checkTmobile: (state) => state.forms.checkTmobile,
      checkYoufone: (state) => state.forms.checkYoufone,
      checkKpn: (state) => state.forms.checkKpn,
    }),
    durationDefault() {
      return this.form.data.fields[this.index].filter(
        (x) => x.type === "duration" && x.group === this.group
      )[0].default;
    },
    props() {
      let items = this.groupBy(this.data, "category_field");
      if (this.currentRates.length <= 0) {
        return [];
      }

      let y = {};

      Object.values(items).map((e) => {
        let a = e.filter(
          (x) => x.rate_period.indexOf(this.getRatePeriod(this.group)) != -1
        );
        if (a.length > 0) {
          y[a[0].category_field] = a;
        }
      });

      if (this.group === "internet") {
        if (y.internet && y.internet[0].title === "Vodafone Ziggo") {
          let filteredByMaxSpeed = y.internet.filter(
            (x) =>
              parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) <=
              this.checkZiggo.speed.orderable
          );
          let plusOne = y.internet.filter(
            (x) =>
              parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) >=
              this.checkZiggo.speed.orderable
          );
          if (filteredByMaxSpeed.length < 1) {
            // y.internet = [y.internet[0],y.internet[1]];
          } else if (
            filteredByMaxSpeed.length < y.internet.length &&
            this.checkZiggo.speed.orderable <
              parseInt(JSON.parse(plusOne[0].name).nl.match(this.regexNumber))
          ) {
            // y.internet = [...filteredByMaxSpeed, ...[plusOne[0]]];
            y.internet = [...filteredByMaxSpeed];
          } else {
            y.internet = filteredByMaxSpeed;
          }
          if (
            y.internet.filter((x) => this.defaultIds.includes(x.id)).length < 1
          ) {
            this.setDefault(y.internet[0].id);
          }
        } else if (y.internet && y.internet[0].title === "KPN") {
          let filteredByMaxSpeed = y.internet.filter(
            (x) =>
              parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) <=
              this.checkKpn.speed.orderable
          );
          let plusOne = y.internet.filter(
            (x) =>
              parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) >=
              this.checkKpn.speed.orderable
          );
          if (filteredByMaxSpeed.length < 1) {
            // y.internet = [y.internet[0], y.internet[1]];
          } else if (
            filteredByMaxSpeed.length < y.internet.length &&
            this.checkKpn.speed.orderable <
              parseInt(JSON.parse(plusOne[0].name).nl.match(this.regexNumber))
          ) {
            y.internet = [...filteredByMaxSpeed, ...[plusOne[0]]];
          } else {
            y.internet = filteredByMaxSpeed;
          }
          if (
            y.internet.filter((x) => this.defaultIds.includes(x.id)).length < 1
          ) {
            this.setDefault(y.internet[0].id);
          }
        } else if (y.internet && y.internet[0].title === "Youfone") {
          let filteredByMaxSpeedFiber = [];
          let filteredByMaxSpeedDsl = [];
          let plusOne = [];
          if (this.checkYoufone.speed.type === "Dsl") {
            filteredByMaxSpeedDsl = y.internet.filter(
              (x) =>
                parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) <=
                  this.checkYoufone.speed.orderable &&
                this.parseJSONSupplierName(x.name, this.lang).split(" ")[0] ===
                  "DSL"
            );
            plusOne = y.internet.filter(
              (x) =>
                parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) >=
                  this.checkYoufone.speed.orderable &&
                this.parseJSONSupplierName(x.name, this.lang).split(" ")[0] ===
                  "DSL"
            );
            let a = plusOne.length > 0 ? plusOne : filteredByMaxSpeedDsl;
            if (filteredByMaxSpeedDsl.length < 1) {
              y.internet = [y.internet[0]];
            } else if (
              filteredByMaxSpeedDsl.length < y.internet.length &&
              this.checkYoufone.speed.orderable <
                parseInt(JSON.parse(a[0].name).nl.match(this.regexNumber))
            ) {
              y.internet = [...filteredByMaxSpeedDsl, ...[plusOne[0]]];
            } else {
              y.internet = filteredByMaxSpeedDsl;
            }
            if (
              y.internet.filter((x) => this.defaultIds.includes(x.id)).length <
              1
            ) {
              this.setDefault(y.internet[0].id);
            }
          } else if (this.checkYoufone.speed.type === "Fiber") {
            filteredByMaxSpeedFiber = y.internet.filter(
              (x) =>
                parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) <=
                  this.checkYoufone.speed.orderable &&
                (this.parseJSONSupplierName(x.name, this.lang).split(" ")[0] ===
                  "Fiber" ||
                  this.parseJSONSupplierName(x.name, this.lang).split(
                    " "
                  )[0] === "Glasvezel")
            );
            plusOne = y.internet.filter(
              (x) =>
                parseInt(JSON.parse(x.name).nl.match(this.regexNumber)) >=
                  this.checkYoufone.speed.orderable &&
                (this.parseJSONSupplierName(x.name, this.lang).split(" ")[0] ===
                  "Fiber" ||
                  this.parseJSONSupplierName(x.name, this.lang).split(
                    " "
                  )[0] === "Glasvezel")
            );
            let a = plusOne.length > 0 ? plusOne : filteredByMaxSpeedFiber;
            if (filteredByMaxSpeedFiber.length < 1) {
              y.internet = [y.internet[0]];
            } else if (
              filteredByMaxSpeedFiber.length < y.internet.length &&
              this.checkYoufone.speed.orderable <
                parseInt(JSON.parse(a[0].name).nl.match(this.regexNumber))
            ) {
              y.internet = [...filteredByMaxSpeedFiber, ...[plusOne[0]]];
            } else {
              y.internet = filteredByMaxSpeedFiber;
            }
            if (
              y.internet.filter((x) => this.defaultIds.includes(x.id)).length <
              1
            ) {
              this.setDefault(y.internet[0].id);
            }
          }
        } else if (y.internet && y.internet[0].title === "T-Mobile") {
          let filteredByUnitKey = [];
          let temp = y.internet;
          y.internet.map((a) => {
            let temp = this.overview
              .filter((x) => x.id === 4)[0]
              .rates.filter((x) => x.proposition_id === a.id)[0];
            if (this.checkTmobile.speed.orderable.includes(temp.unit_key)) {
              filteredByUnitKey.push(a);
            }
          });
          y.internet = [...filteredByUnitKey];
          if (
            y.internet.filter((x) => this.defaultIds.includes(x.id)).length < 1
          ) {
            if (y.internet[0]) {
              this.setDefault(y.internet[0].id);
            } else {
              this.setDefault(temp[0].id);
            }
          }
          if (y.internet.length < 1) {
            let packages = this.overview.filter((x) => x.id === 4)[0].packages;
            packages.map((a, index) => {
              if (a.category_field === "internet") {
                this.overview
                  .filter((x) => x.id === 4)[0]
                  .packages.splice(index, 1);
                this.overview.filter((x) => x.id === 4)[0].packagestotal -=
                  a.yearly;
                this.overview.filter((x) => x.id === 4)[0].yearly -=
                  a.yearly * 12;
                this.setOverview();
              }
            });
          }
        }
      }
      this.setValues(y);

      this.defaultIds.map((id) => {
        Object.values(y).map((x) => {
          x.map((a) => {
            if (a.id === id) {
              a.status = 1;
            }
          });
        });
      });

      return y;
    },
    currentOverview() {
      return this.overview.filter((x) => x.id === this.data[0].product_id)[0];
    },
    currentRates() {
      return this.currentOverview.rates;
    },
    defaultIds() {
      return this.data.filter((a) => a.default !== null).map((a) => a.id);
    },
    currentRules() {
      return this.currentOverview.rules
        ? this.currentOverview.rules.filter((a) => a.supplier == this.supplier)
            .length > 0
          ? this.currentOverview.rules.filter(
              (a) => a.supplier == this.supplier
            )
          : []
        : [];
    },
  },
  methods: {
    ...mapMutations({
      setModalContentComputed: "forms/SET_MODAL_CONTENT_COMPUTED",
    }),
    openModal(item) {
      if (this.currentRates && this.currentRates.length > 0) {
        this.setModalContentComputed({
          title:
            this.currentRates.filter((a) => a.proposition_id == item.id)
              .length > 0
              ? this.currentRates.filter((a) => a.proposition_id == item.id)[0]
                  .title
                ? this.currentRates.filter(
                    (a) => a.proposition_id == item.id
                  )[0].title[this.lang]
                : null
              : null,
          description:
            this.currentRates.filter((a) => a.proposition_id == item.id)
              .length > 0
              ? this.currentRates.filter((a) => a.proposition_id == item.id)[0]
                  .description
                ? this.currentRates.filter(
                    (a) => a.proposition_id == item.id
                  )[0].description[this.lang]
                : null
              : null,
        });
        // e.stopPropagation();
        // window.$("#computedInfo").modal();
      }
    },
    setDefault(id) {
      this.changeStatus(id, "internet");
    },
    getDiscountByRate(packages, rates, duration) {
      let discountIds = [];
      let discountsByRate = [];
      let discountsByRateArr = [];

      packages.forEach((i) => {
        discountIds.push(i.id);
      });

      discountsByRate = rates.filter(
        (a) =>
          a.rate_period == duration &&
          discountIds.includes(a.proposition_id) &&
          a.discount.filter((x) => x.type == "discount").length > 0
      );

      discountsByRate.forEach((item) => {
        item.discount.forEach((discount) => {
          discountsByRateArr.push({
            period: discount.duration,
            id: discount.id,
            rate: Math.abs(discount.rate),
            type: discount.type,
          });
        });
      });

      return discountsByRateArr;
    },
    getDiscountByRule(rules) {
      let tempRules = [];

      if (rules.length <= 0) {
        return tempRules;
      }

      rules.forEach((rule) => {
        tempRules.push({
          period: rule.period,
          id: rule.id,
          rate: Math.abs(rule.rate),
          type: rule.type,
        });
      });

      return tempRules;
    },
    sortDiscount(arr) {
      return _.orderBy(arr, ["period"], ["asc"]);
    },
    setDiscount() {
      let discountByTotal = [];
      this.currentOverview.discounts = [];
      this.currentOverview.discountTotal = 0;

      let discountByRate = this.getDiscountByRate(
        this.currentOverview.packages,
        this.currentRates,
        this.durationDefault
      );

      let discountByRules = this.getDiscountByRule(this.currentRules);

      discountByTotal = [...discountByRate, ...discountByRules];

      let discountByTotalSorted = this.sortDiscount(discountByTotal);

      discountByTotalSorted.forEach((i, index1) => {
        discountByTotalSorted
          .filter((a) => a.period >= i.period)
          .forEach((a, index2) => {
            if (index2 > index1) {
              i.rate += a.rate;
            }
            if (index1 > index2 && a.period == i.period) {
              i.rate = 0;
            }
          });

        i.periodStarted = discountByTotalSorted[index1 - 1]
          ? discountByTotalSorted[index1 - 1].period
          : 0;
        i.periodFinished = discountByTotalSorted[index1 + 1]
          ? discountByTotalSorted[index1 + 1].period
          : i.period;

        this.currentOverview.discounts.push(i);
        this.currentOverview.discountTotal =
          this.currentOverview.discountTotal +
          i.rate * (i.periodFinished - i.periodStarted);
      });
    },
    changeStatus(id, field) {
      this.data
        .filter((a) => a.category_field == field)
        .forEach((item) => {
          if (item.id === id) {
            item.default = id;
            item.status = 1;
          } else {
            item.status = 0;
            item.default = null;
          }
        });
    },
    setValues(y) {
      //mobile youfone
      if (this.group === "mobile" && this.data[0].supplier_id == 57) {
        this.currentOverview.packages = [];
        let defaultCall = this.data.filter(
          (a) => a.category_field == "call" && a.default > 0
        )[0];
        let defaultInternet = this.data.filter(
          (a) => a.category_field == "internet" && a.default > 0
        )[0];
        this.data
          .filter((a) => a.category_field === "call")
          .forEach((item) => {
            this.currentRates
              .filter(
                (y) =>
                  y.proposition_id === item.id &&
                  y.rate_period == this.durationDefault &&
                  y.rules !== null
              )
              .forEach((r) => {
                if (item.id === defaultCall.id) {
                  Object.keys(r.rules.price).forEach((x) => {
                    if (this.data.filter((a) => a.id == x).length > 0) {
                      this.data.filter((a) => a.id == x)[0].difyearly =
                        r.rules.price[x];
                      if (x == defaultInternet.id) {
                        item.difyearly = r.rules.price[x];
                      }
                    }
                  });
                } else {
                  item.difyearly = r.rules.price[defaultInternet.id];
                }
              });
          });
        this.data.forEach((item) => {
          item.packagesdiff = parseFloat(
            item.difyearly - defaultCall.difyearly
          );
          if (item.id == defaultCall.id || item.id == defaultInternet.id) {
            this.currentOverview.packages.push(item);
          }
        });
        this.currentOverview.packagestotal = parseFloat(defaultCall.difyearly);
        this.currentOverview.total = 0;
        this.currentOverview.yearly = this.currentOverview.packagestotal * 12;

        this.setDiscount();
      }
      //mobile and internet kpn
      if (this.data[0].supplier_id == 3) {
        this.currentOverview.packages = [];
        this.currentOverview.packagestotal = 0;

        let tempProps = this.groupBy(this.data, "category_field");

        Object.values(tempProps).forEach((tempProp) => {
          let tempDefaultItem = tempProp.filter((a) => a.default > 0)[0];
          tempProp.forEach((tempItem) => {
            this.data.filter((a) => a.id == tempItem.id)[0].packagesdiff =
              parseFloat(tempItem.yearly - tempDefaultItem.yearly);
            if (tempItem.default > 0) {
              this.currentOverview.packages.push(tempItem);
              this.currentOverview.packagestotal += parseFloat(tempItem.yearly);
            }
          });
        });

        this.currentOverview.total = 0;
        this.currentOverview.yearly =
          parseFloat(this.currentOverview.packagestotal) * 12;

        this.setDiscount();
      }
      // internet t-mobile
      if (this.group === "internet" && this.data[0].supplier_id == 11) {
        //create constant
        this.data.forEach((item) => {
          item.yearly = this.currentRates.filter(
            (a) =>
              a.proposition_id == item.id &&
              a.rate_period == this.durationDefault
          )[0].rate;
        });

        this.currentOverview.packages = [];
        let defaultMobileSubscription = this.data.filter(
          (a) => a.category_field == "mobile" && a.default > 0
        )[0];

        let defaultInternet = this.data.filter(
          (a) => a.category_field == "internet" && a.default > 0
        )[0]
          ? this.data.filter(
              (a) => a.category_field == "internet" && a.default > 0
            )[0]
          : this.data.filter((a) => a.category_field == "internet")[0];

        this.data.forEach((item) => {
          if (item.category_field == "mobile") {
            let r = this.currentRates.filter(
              (y) =>
                y.proposition_id === item.id &&
                y.rate_period == this.durationDefault
            )[0];

            if (r.rules != null && item.id === defaultMobileSubscription.id) {
              this.data
                .filter((a) => a.category_field === "internet")
                .forEach((a) => {
                  a.yearly = parseFloat(r.rules.price[a.id] ?? a.yearly);
                  a.difyearly = parseFloat(a.yearly);
                  if (a.id == defaultInternet.id) {
                    if (y.internet.length > 0) {
                      item.difyearly = parseFloat(
                        r.rules.price[a.id] ?? a.difyearly
                      );
                    }
                  }
                });
            } else if (
              r.rules == null &&
              item.id === defaultMobileSubscription.id
            ) {
              this.data
                .filter((a) => a.category_field === "internet")
                .forEach((a) => {
                  a.yearly = this.currentRates.filter(
                    (c) =>
                      c.proposition_id == a.id &&
                      c.rate_period == this.durationDefault
                  )[0].rate;
                  a.difyearly = parseFloat(a.yearly);
                });
              if (y.internet.length > 0) {
                item.difyearly =
                  parseFloat(defaultInternet.yearly) + parseFloat(item.yearly);
              }
            } else if (
              item.id != defaultMobileSubscription.id &&
              r.rules != null
            ) {
              if (y.internet.length > 0) {
                item.difyearly = parseFloat(
                  r.rules.price[defaultInternet.id] ?? defaultInternet.yearly
                );
              }
            } else {
              if (y.internet.length > 0) {
                item.difyearly =
                  parseFloat(defaultInternet.yearly) + parseFloat(item.yearly);
              }
            }

            if (y.internet.length < 1) {
              item.difyearly =
                parseFloat(defaultMobileSubscription.yearly) +
                parseFloat(item.yearly);
            }
          } else if (
            item.category_field != "mobile" &&
            item.category_field != "internet"
          ) {
            item.difyearly = parseFloat(item.yearly);
          }
        });

        this.data.forEach((item) => {
          if (item.category_field !== "internet") {
            item.packagesdiff = parseFloat(
              item.difyearly -
                this.data.filter(
                  (a) =>
                    a.category_field == item.category_field && a.default > 0
                )[0].difyearly
              // ? this.data.filter(
              //   (a) => a.category_field == item.category_field && a.default > 0
              // )[0].difyearly : this.data.filter(
              //   (a) => a.category_field == item.category_field
              // )[0].difyearly
            );
          } else {
            if (y.internet.length > 0) {
              item.packagesdiff = parseFloat(
                item.difyearly -
                  this.data.filter(
                    (a) =>
                      a.category_field == item.category_field && a.default > 0
                  )[0].difyearly
                // ? this.data.filter(
                //   (a) => a.category_field == item.category_field && a.default > 0
                // )[0].difyearly : this.data.filter(
                //   (a) => a.category_field == item.category_field
                // )[0].difyearly
              );
            }
          }

          if (this.defaultIds.includes(item.id)) {
            if (item.category_field !== "internet") {
              this.currentOverview.packages.push(item);
            } else {
              if (y.internet.length > 0) {
                this.currentOverview.packages.push(item);
              }
            }
          }
        });
        this.currentOverview.packagestotal =
          this.currentOverview.packages.reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b.yearly);
          }, 0);
        this.currentOverview.total = 0;
        this.currentOverview.yearly = this.currentOverview.packagestotal * 12;
      }

      //internet ziggo and youfone
      if (
        this.group === "internet" &&
        (this.data[0].supplier_id == 57 || this.data[0].supplier_id == 1)
      ) {
        this.currentOverview.packages = [];
        let defaultTv = this.data.filter(
          (a) => a.category_field == "tv" && a.default > 0
        )[0];
        let defaultInternet = this.data.filter(
          (a) => a.category_field == "internet" && a.default > 0
        )[0];
        this.data.forEach((item) => {
          if (item.category_field === "internet") {
            let r = this.currentRates.filter(
              (y) =>
                y.proposition_id === item.id &&
                y.rate_period == this.durationDefault
            )[0];

            if (item.id === defaultInternet.id && r.rules != null) {
              this.data
                .filter((a) => a.category_field === "tv")
                .forEach((a) => {
                  a.difyearly = r.rules.price[a.id] ?? r.rate;
                  if (a.id == defaultTv.id) {
                    item.yearly = r.rules.price[a.id] ?? r.rate;
                    item.difyearly = r.rules.price[a.id] ?? r.rate;
                  }
                });
            } else if (item.id === defaultInternet.id && r.rules == null) {
              this.data
                .filter((a) => a.category_field === "tv")
                .forEach((a) => {
                  a.difyearly = item.yearly;
                });
              item.difyearly = item.yearly;
            } else if (item.id != defaultInternet.id && r.rules != null) {
              item.difyearly = r.rules.price[defaultTv.id] ?? r.rate;
            } else {
              item.difyearly = item.yearly;
            }
          } else if (
            item.category_field != "tv" &&
            item.category_field != "internet"
          ) {
            item.difyearly = item.yearly;
          }
        });
        this.data.forEach((item) => {
          if (
            item.category_field === "tv" ||
            item.category_field === "internet"
          ) {
            item.packagesdiff = parseFloat(
              item.difyearly - defaultInternet.difyearly
            );
          }
          item.packagesdiff = parseFloat(
            item.difyearly -
              this.data.filter(
                (a) =>
                  a.category_field == item.category_field && a.default !== null
              )[0].difyearly
          );
          if (this.defaultIds.includes(item.id)) {
            this.currentOverview.packages.push(item);
          }
        });
        this.currentOverview.packagestotal =
          this.currentOverview.packages.reduce(function (a, b) {
            return parseFloat(a) + parseFloat(b.yearly);
          }, 0);
        this.currentOverview.total = 0;
        this.currentOverview.yearly = this.currentOverview.packagestotal * 12;
      }
      this.setDiscount();
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    },
  },
};
</script>

<style scoped></style>
